// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ResetPasswordForm_errorMessage__1dNc4","resetButton":"ResetPasswordForm_resetButton__xyOc2"};